import { apiClient } from '../ruutsApi/client'
import endpoints from '../ruutsApi/endpoints'
import { unwrapCollection } from '../ruutsApi/normalize'

/**
 * Types pinned here: `unwrapCollection` has no inference site in plain JS, so it widens to
 * `unknown[]` and the TypeScript consumers would need a cast on their side.
 *
 * @param {{ farmId: string, year?: string, namespace?: string, signal?: AbortSignal }} args
 * @returns {Promise<{ id: string }[]>}
 */
export default async function getUnusedPaddocks({ farmId, year, namespace, signal }) {
  const response = await apiClient.get(`${endpoints.paddocks}/unused`, {
    params: { farmId, year, namespace },
    signal,
  })
  return unwrapCollection(response)
}
